exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-size-initial[data-v-06e87c9e]{font-size:medium}", ""]);

// exports
